import { Country } from '../country/country.model';

export class User {
  readonly firstName!: string;
  readonly lastName!: string;
  readonly email!: string;
  readonly userId!: string;
  readonly siteCode!: number;
  readonly country!: Country;
  readonly phone!: string;
  readonly jobTitle!: string;
  readonly subDivisionUidK!: number;
  readonly bkSubDivisionC!: string;
  readonly countryUidK!: number;
  readonly language!: string;
  readonly countryTimeZoneC!: number;

  static fromJSON(input: object) {
    return Object.assign(new User(), input);
  }
}
